module.exports = __webpack_public_path__ + "img/Icon__Child_right.8e23135a.svg";